import { useGetReportAction } from './report-action-hook'
import { useGetDashboard } from './get-dashboard-hook'
export {
  useGetReportAction,
  useGetDashboard
}